import React, { useState } from "react";
import { startCampaign, getCampaignStatus } from "./notificationApi";
import { Card, Button, Input, TextArea, Select, Badge } from "../../components/common";

export default function SendNotificationForm() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [language, setLanguage] = useState<"english" | "turkish">("english");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [campaignId, setCampaignId] = useState("");
  const [campaignStatus, setCampaignStatus] = useState<any>(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const [statusError, setStatusError] = useState<string | null>(null);

  // Sadece kampanya gönderimi
  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const res = await startCampaign({
        title,
        body,
        data: { route: "home" },
        target: { type: "all", value: null, language },
        dryRun: false,
      });
      setResult("Kampanya başlatıldı! ID: " + res?.id || JSON.stringify(res));
      if (res?.id) setCampaignId(res.id);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusCheck = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatusLoading(true);
    setStatusError(null);
    setCampaignStatus(null);
    try {
      const status = await getCampaignStatus(campaignId);
      setCampaignStatus(status);
    } catch (err: any) {
      setStatusError(err.message);
    } finally {
      setStatusLoading(false);
    }
  };

  return (
    <Card title="Kampanya Bildirimi Gönder" className="card" >
      <form onSubmit={handleSend} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <Input
          label="Başlık"
          value={title}
          onChange={e => setTitle(e.target.value)}
          placeholder="Bildirim başlığı"
          required
        />
        <TextArea
          label="Mesaj"
          value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Bildirim mesajı"
          required
          rows={3}
        />
        <Select
          label="Dil"
          value={language}
          onChange={e => setLanguage(e.target.value as any)}
          options={[
            { value: "english", label: "English" },
            { value: "turkish", label: "Turkish" },
          ]}
        />
        <Button type="submit" variant="primary" size="lg" disabled={loading}>
          {loading ? "Kampanya başlatılıyor..." : "Kampanya Başlat"}
        </Button>
        {error && <Badge variant="danger">{error}</Badge>}
        {result && (
          <pre style={{
            background: "#181f2a",
            color: "#f1f5f9",
            borderRadius: 12,
            padding: 16,
            fontSize: 13,
            marginTop: 8,
            overflow: "auto"
          }}>{result}</pre>
        )}
      </form>
      <div style={{ marginTop: 32 }}>
        <h3 style={{ color: "#f59e0b", fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Kampanya Durumu Sorgula</h3>
        <form onSubmit={handleStatusCheck} style={{ display: "flex", gap: 12, alignItems: "flex-end" }}>
          <Input
            label="Kampanya ID"
            value={campaignId}
            onChange={e => setCampaignId(e.target.value)}
            placeholder="Kampanya ID girin"
            style={{ minWidth: 180 }}
          />
          <Button type="submit" variant="secondary" size="md" disabled={statusLoading || !campaignId}>
            {statusLoading ? "Sorgulanıyor..." : "Durumu Sorgula"}
          </Button>
        </form>
        {statusError && <Badge variant="danger">{statusError}</Badge>}
        {campaignStatus && (
          <pre style={{
            background: "#181f2a",
            color: "#f1f5f9",
            borderRadius: 12,
            padding: 16,
            fontSize: 13,
            marginTop: 8,
            overflow: "auto"
          }}>{JSON.stringify(campaignStatus, null, 2)}</pre>
        )}
      </div>
    </Card>
  );
}
